

















































































































































































































































































































































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import FlatpageLegalBase from 'frontend/views/flatpages/FlatpageLegalBase.vue';

@Component({
  metaInfo() {
    return {
      title: 'Privacy Policy',
    };
  },
  components: {
    FlatpageLegalBase,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PrivacyPolicy2014 extends Vue {}
